var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNewsletter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 13,
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2727 5.04553V11.1065C15.2727 11.4905 15.1229 11.8185 14.8228 12.0912C14.5227 12.3638 14.1628 12.5001 13.7425 12.5001H1.53024C1.1105 12.5001 0.750029 12.3638 0.449908 12.0912C0.150335 11.8185 0 11.4905 0 11.1065V5.04553L7.65118 8.1364L15.2727 5.04553ZM15.2727 4.1063L7.65118 7.22765L0 4.1063V1.89425C0 1.51025 0.150335 1.18166 0.449908 0.909031C0.750029 0.636405 1.1105 0.500092 1.53024 0.500092H13.7425C14.1628 0.500092 14.5227 0.636405 14.8228 0.909031C15.1229 1.18166 15.2727 1.51025 15.2727 1.89425V4.1063Z",
  fill: "#FFCA05"
})));
export default SvgIconNewsletter;